<template>
	<div class="pi-page">
		<div class="pi-inner">
			<template v-if="tab === 0">
				<!-- 解读说明 -->
				<div class="pi-desc-title">农业农村部“农产品批发价格200指数解读”说明</div>
				<div class="pi-desc-text" v-html="descText"></div>

				<!-- 日度 / 月度 切换（表） -->
				<div class="pi-toggle center">
					<span :class="{ on: freq === '日度' }" @click="freq = '日度'">日度</span>
					<span :class="{ on: freq === '月度' }" @click="freq = '月度'">月度</span>
				</div>

				<!-- 数据表 -->
				<div class="pi-block">
					<div class="pi-block-title">
						<img :src="icons.chart" class="pi-ico" alt="" />
						<span>{{ tableTitle }}</span>
					</div>
					<div class="pi-table-wrap">
						<table class="pi-table">
							<thead>
								<tr>
									<th>时间</th>
									<th>农产品批发价格200指数</th>
									<th>“菜篮子”产品批发价格200指数</th>
									<th>粮油产品批发价格200指数</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="row in tableRows" :key="row.date">
									<td>{{ row.date }}</td>
									<td>{{ row.p200 }}</td>
									<td>{{ row.lanzi }}</td>
									<td>{{ row.liangyou }}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>

				<!-- 走势图 -->
				<div class="pi-block">
					<div class="pi-chart-head">
						<div class="pi-block-title">
							<img :src="icons.chart" class="pi-ico" alt="" />
							<span>{{ chartTitle }}</span>
						</div>
						<div class="pi-chart-right">
							<span class="pi-chart-note">注：定基指数，以2015年为100计算</span>
							<span class="pi-toggle small">
								<span :class="{ on: chartFreq === '日度' }" @click="setChartFreq('日度')">日度</span>
								<span :class="{ on: chartFreq === '月度' }" @click="setChartFreq('月度')">月度</span>
							</span>
						</div>
					</div>
					<div ref="trendChart" class="pi-chart"></div>
				</div>
			</template>

			<div v-else class="pi-empty">该指数数据开发中，敬请期待</div>
		</div>
	</div>
</template>

<script>
	import * as echarts from 'echarts'

	const OBS = 'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/hg/webIcon/'

	function pad(n) {
		return n < 10 ? '0' + n : '' + n
	}
	// 生成走势假数据：先升后降，粮油基本走平
	function genSeries(startStr, count, stepDays) {
		const dates = []
		const p = []
		const l = []
		const y = []
		const start = new Date(startStr)
		for (let i = 0; i < count; i++) {
			const d = new Date(start.getTime() + i * stepDays * 86400000)
			dates.push(d.getFullYear() + '年' + pad(d.getMonth() + 1) + '月' + pad(d.getDate()) + '日')
			const t = count > 1 ? i / (count - 1) : 0
			const base = 113 + 5 * Math.sin(Math.PI * t) - 2 * t
			p.push(+base.toFixed(2))
			l.push(+(base + 0.5).toFixed(2))
			y.push(+(114 + 0.3 * Math.sin(i / 6)).toFixed(2))
		}
		return { dates, p, l, y }
	}

	export default {
		name: 'PriceIndex',
		data() {
			return {
				icons: {
					chart: OBS + 'shujutongji.png',
				},
				indexTabs: [
					'农产品批发价格200指数',
					'隆内型白条猪肉出厂价格指数',
					'中国遵义朝天椒（干椒）批发价格指数',
				],
				tab: 0,
				freq: '日度',
				chartFreq: '日度',
				// 数据表（假数据，接口就绪后替换）
				tableData: {
					日度: [{
							date: '2026-10-29', p200: 111.42, lanzi: 110.97, liangyou: 114.12
						}, {
							date: '2026-10-28', p200: 111.53, lanzi: 111.1, liangyou: 114.08
						}, {
							date: '2026-10-27', p200: 111.58, lanzi: 111.15, liangyou: 114.14
						}, {
							date: '2026-10-26', p200: 111.64, lanzi: 111.22, liangyou: 114.11
						}, {
							date: '2026-10-25', p200: 111.48, lanzi: 111.04, liangyou: 114.11
						}, {
							date: '2026-10-24', p200: 110.5, lanzi: 110.1, liangyou: 112.85
						}, {
							date: '2026-10-23', p200: 111.58, lanzi: 111.14, liangyou: 114.23
						}, {
							date: '2026-10-22', p200: 111.73, lanzi: 111.32, liangyou: 114.16
						}, {
							date: '2026-10-21', p200: 112, lanzi: 111.64, liangyou: 114.14
						}, {
							date: '2026-10-20', p200: 111.9, lanzi: 111.5, liangyou: 114.2
						}, {
							date: '2026-10-19', p200: 111.8, lanzi: 111.4, liangyou: 114.18
						}, {
							date: '2026-10-18', p200: 111.75, lanzi: 111.35, liangyou: 114.15
						},
					],
					月度: [{
							date: '2026-10', p200: 112.1, lanzi: 111.6, liangyou: 114.1
						}, {
							date: '2026-09', p200: 115.3, lanzi: 115.0, liangyou: 114.3
						}, {
							date: '2026-08', p200: 116.8, lanzi: 116.5, liangyou: 114.2
						}, {
							date: '2026-07', p200: 115.9, lanzi: 115.4, liangyou: 114.0
						}, {
							date: '2026-06', p200: 114.2, lanzi: 113.7, liangyou: 113.9
						}, {
							date: '2026-05', p200: 113.1, lanzi: 112.6, liangyou: 113.8
						}, {
							date: '2026-04', p200: 112.4, lanzi: 111.9, liangyou: 113.7
						}, {
							date: '2026-03', p200: 111.8, lanzi: 111.3, liangyou: 113.6
						}, {
							date: '2026-02', p200: 112.6, lanzi: 112.1, liangyou: 113.9
						}, {
							date: '2026-01', p200: 113.4, lanzi: 112.9, liangyou: 114.0
						},
					],
				},
				// 走势图（假数据）
				chartData: {
					日度: genSeries('2026-08-01', 80, 1),
					月度: genSeries('2025-11-01', 12, 30),
				},
				_chart: null,
				_resizeHandler: null,
			}
		},
		computed: {
			tableRows() {
				return this.tableData[this.freq] || []
			},
			tableTitle() {
				return `农业农村部“农产品批发价格200指数”${this.freq}数据`
			},
			chartTitle() {
				return `农业农村部“农产品批发价格200指数”${this.chartFreq}走势图`
			},
			descText() {
				const r = (this.tableData['日度'] || [])[0] || {}
				return `据农业农村部“全国农产品批发市场价格信息系统”监测：${r.date}，农产品批发价格200指数是 <b>${r.p200}</b>（以2015年为100），“菜篮子”产品批发价格200指数是 <b>${r.lanzi}</b>（以2015年为100）。`
			},
		},
		mounted() {
			this.$nextTick(() => this.renderChart())
			this._resizeHandler = () => this._chart && this._chart.resize()
			window.addEventListener('resize', this._resizeHandler)
			this.fetchIndex()
		},
		beforeDestroy() {
			window.removeEventListener('resize', this._resizeHandler)
			if (this._chart) {
				this._chart.dispose()
				this._chart = null
			}
		},
		methods: {
			// 价格指数不分页整份取回：category=1，日度(period=1)与月度(period=3)各发一次，分别回填表与走势图
			fetchIndex() {
				this.fetchIndexByPeriod(1, '日度')
				this.fetchIndexByPeriod(3, '月度')
			},
			fetchIndexByPeriod(period, freqKey) {
				this.$request2('/admin-api/governance/pfsc-source-data/item-list', { params: { category: 1, period: period } }).then(res => {
					if (!res || res.code !== 0 || !Array.isArray(res.data) || !res.data.length) return
					const rows = res.data.map(it => this.parseIndexRow(it)).filter(Boolean).sort((a, b) => (a.date < b.date ? 1 : -1))
					if (!rows.length) return
					this.tableData[freqKey] = rows.map(r => ({ date: r.date, p200: r.p200, lanzi: r.lanzi, liangyou: r.liangyou }))
					this.chartData[freqKey] = this.buildChart(rows)
					this.renderChart()
				}).catch(() => {})
			},
			parseIndexRow(it) {
				let obj = null
				try { obj = JSON.parse(it.data) } catch (e) { return null }
				if (!obj) return null
				const date = obj.publishDate || it.dataDate
				if (!date) return null
				return { period: it.period, date: date, p200: obj.agriculture, lanzi: obj.vegetableBasket, liangyou: obj.grainAndOil }
			},
			// 走势图需按时间正序（旧→新）；rows 为新→旧，此处反转
			buildChart(rows) {
				const asc = rows.slice().sort((a, b) => (a.date < b.date ? -1 : 1))
				return {
					dates: asc.map(r => this.formatDateCN(r.date)),
					p: asc.map(r => r.p200),
					l: asc.map(r => r.lanzi),
					y: asc.map(r => r.liangyou),
				}
			},
			formatDateCN(s) {
				const m = String(s).match(/(\d{4})-(\d{2})-(\d{2})/)
				return m ? m[1] + '年' + m[2] + '月' + m[3] + '日' : String(s)
			},
			switchTab(i) {
				this.tab = i
				if (i === 0) this.$nextTick(() => this.renderChart())
			},
			setChartFreq(f) {
				if (this.chartFreq === f) return
				this.chartFreq = f
				this.renderChart()
			},
			renderChart() {
				const el = this.$refs.trendChart
				if (!el) return
				if (!this._chart) this._chart = echarts.init(el)
				const d = this.chartData[this.chartFreq]
				const legend = ['农产品批发价格200指数', '“菜篮子”产品批发价格200指数', '粮油产品批发价格200指数']
				this._chart.setOption({
					backgroundColor: 'transparent',
					tooltip: { trigger: 'axis' },
					legend: { data: legend, top: 6, itemWidth: 14, itemHeight: 8, textStyle: { color: '#666', fontSize: 12 } },
					grid: { left: 46, right: 24, top: 46, bottom: 34 },
					xAxis: {
						type: 'category', boundaryGap: false, data: d.dates,
						axisLine: { lineStyle: { color: '#ccc' } },
						axisLabel: { color: '#666', fontSize: 11 },
					},
					yAxis: {
						type: 'value', scale: true,
						axisLabel: { color: '#666' },
						splitLine: { lineStyle: { type: 'dashed', color: '#eee' } },
					},
					series: [
						{ name: legend[0], type: 'line', smooth: true, showSymbol: false, data: d.p, itemStyle: { color: '#e6a23c' }, lineStyle: { color: '#e6a23c', width: 1.5 } },
						{ name: legend[1], type: 'line', smooth: true, showSymbol: false, data: d.l, itemStyle: { color: '#22b573' }, lineStyle: { color: '#22b573', width: 1.5 } },
						{ name: legend[2], type: 'line', smooth: true, showSymbol: false, data: d.y, itemStyle: { color: '#409eff' }, lineStyle: { color: '#409eff', width: 1.5 } },
					],
				}, true)
				this._chart.resize()
			},
		},
	}
</script>

<style scoped lang="scss">
	.pi-page {
		flex: 1;
		min-height: 0;
		overflow: auto;
		background: #f5f6f8;
		box-sizing: border-box;
	}

	.pi-inner {
		max-width: 1300px;
		margin: 0 auto;
		padding: 0 20px 40px;
	}

	/* ===== 顶部指数 tab ===== */
	.pi-tabs {
		display: flex;
		align-items: center;
		justify-content: space-around;
		border-bottom: 1px solid #e5e5e5;
		padding: 0 10px;
	}

	.pi-tab {
		position: relative;
		padding: 16px 6px;
		font-size: 15px;
		color: #333;
		cursor: pointer;
		white-space: nowrap;
	}

	.pi-tab.active {
		color: #22b573;
		font-weight: 600;
	}

	.pi-tab.active::after {
		content: '';
		position: absolute;
		left: 0;
		right: 0;
		bottom: -1px;
		height: 2px;
		background: #22b573;
	}

	/* ===== 解读说明 ===== */
	.pi-desc-title {
		margin-top: 22px;
		text-align: center;
		font-size: 20px;
		font-weight: 700;
		color: #2f7ed8;
	}

	.pi-desc-text {
		margin: 14px auto 0;
		max-width: 1000px;
		font-size: 14px;
		line-height: 1.9;
		color: #333;
		text-indent: 2em;
	}

	.pi-desc-text b {
		color: #d0021b;
	}

	/* ===== 日度/月度 切换 ===== */
	.pi-toggle {
		display: inline-flex;
		border: 1px solid #ddd;
		border-radius: 3px;
		overflow: hidden;
	}

	.pi-toggle.center {
		display: flex;
		width: 160px;
		margin: 22px auto 6px;
	}

	.pi-toggle span {
		flex: 1;
		text-align: center;
		padding: 7px 18px;
		font-size: 14px;
		color: #666;
		background: #fff;
		cursor: pointer;
		user-select: none;
	}

	.pi-toggle span+span {
		border-left: 1px solid #ddd;
	}

	.pi-toggle span.on {
		background: #d0021b;
		color: #fff;
	}

	.pi-toggle.small span {
		padding: 4px 14px;
		font-size: 13px;
	}

	/* ===== 区块 ===== */
	.pi-block {
		margin-top: 24px;
	}

	.pi-block-title {
		display: flex;
		align-items: center;
		font-size: 16px;
		font-weight: 700;
		color: #d0021b;
	}

	.pi-ico {
		width: 20px;
		height: 20px;
		margin-right: 6px;
	}

	/* ===== 数据表 ===== */
	.pi-table-wrap {
		margin-top: 12px;
		max-height: 360px;
		overflow-y: auto;
		border: 1px solid #eee;
		border-radius: 4px;
	}

	.pi-table {
		width: 100%;
		border-collapse: collapse;
		table-layout: fixed;
	}

	.pi-table th {
		position: sticky;
		top: 0;
		background: #22b573;
		color: #fff;
		font-size: 15px;
		font-weight: 600;
		padding: 12px 8px;
		text-align: center;
	}

	.pi-table td {
		padding: 12px 8px;
		text-align: center;
		font-size: 14px;
		color: #333;
		border-bottom: 1px solid #f0f0f0;
	}

	.pi-table tbody tr:nth-child(even) {
		background: #fafafa;
	}

	.pi-table tbody tr:hover {
		background: #f0fff8;
	}

	/* ===== 走势图 ===== */
	.pi-chart-head {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.pi-chart-right {
		display: flex;
		align-items: center;
		gap: 14px;
	}

	.pi-chart-note {
		font-size: 13px;
		color: #999;
	}

	.pi-chart {
		margin-top: 12px;
		width: 100%;
		height: 380px;
		background: #fff;
		border: 1px solid #eee;
		border-radius: 4px;
		box-sizing: border-box;
	}

	.pi-empty {
		padding: 80px 0;
		text-align: center;
		font-size: 16px;
		color: #999;
	}
</style>
